import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import {
  PaymentElement,
  useStripe,
  useElements
} from "@stripe/react-stripe-js";
import { use } from "react";
import { toast } from "react-toastify";

const CheckoutForm = forwardRef(({ startPayment, setSelectedPaymentMethod, onElementsReady, props }, ref) => {
  const stripe = useStripe();
  const elements = useElements();

  const [message, setMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!stripe) {
      return;
    }

    const clientSecret = new URLSearchParams(window.location.search).get(
      "payment_intent_client_secret"
    );

    if (!clientSecret) {
      return;
    }

    stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
      switch (paymentIntent.status) {
        case "succeeded":
          setMessage("Payment succeeded!");
          break;
        case "processing":
          setMessage("Your payment is processing.");
          break;
        case "requires_payment_method":
          setMessage("Your payment was not successful, please try again.");
          break;
        default:
          setMessage("Something went wrong.");
          break;
      }
    });

  }, [stripe]);


  useEffect(() => {
    if (elements && onElementsReady) {
      onElementsReady(elements);
    }
  }, [elements]);

  const formRef = useRef();
  useEffect(() => {

    formRef.current.requestSubmit();

  }, [startPayment]);

  useImperativeHandle(ref, () => ({
    async handleCardValidation() {
      const result = await elements.submit(); // sadece doğrulama yapar
      if (result.error) {
        return false;
      }
      return true;
    },
  }));


  const handleSubmit = async (e) => {
    e.preventDefault();
    props.toggleLoadingOverlay(true);
    if (!stripe || !elements) {
      props.toggleLoadingOverlay(false);
      return;
    }

    setIsLoading(true);

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: `${window.location.origin}/payment-success`,
      },
    });

    if (error?.type === "card_error" || error?.type === "validation_error") {
      setMessage(error.message);
      props.toggleLoadingOverlay(false);
      toast.error(error.message); // Hata mesajını toast ile göster
    } else if (error) {
      setMessage("Beklenmeyen bir hata oluştu.");
      props.toggleLoadingOverlay(false);
      toast.error("Beklenmeyen bir hata oluştu."); // Genel hata
    }
    props.toggleLoadingOverlay(false);

    setIsLoading(false);
  };





  return (
    <form id="payment-form" onSubmit={handleSubmit} ref={formRef}>

      <PaymentElement
        id="payment-element"
        options={{ layout: "tabs" }}
        onChange={(event) => {
          const type = event.value?.type || event.value;
          setSelectedPaymentMethod(`${type?.toUpperCase()}`);
        }}
      />

      <button disabled={isLoading || !stripe || !elements} id="submit">
        <span id="button-text">
          {isLoading ? <div className="spinner" id="spinner"></div> : ""}
        </span>
      </button>
      {/* Show any error or success messages */}
      {message && <div id="payment-message">{message}</div>}
    </form>
  );
});

export default CheckoutForm;